import * as types from './constants';

export const fetchContentRequest = (payload) => ({
  type: types.FETCH_CONTENT_REQUEST,
  payload,
});

export const fetchContentSuccess = (payload) => ({
  type: types.FETCH_CONTENT_SUCCESS,
  payload,
});

export const fetchContentFailure = (payload) => ({
  type: types.FETCH_CONTENT_FAILURE,
  payload,
});
